import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Chip from '@material-ui/core/Chip';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#388e3c'
    },
    secondary: {
      main: '#d50000'
    }
  },
  typography: {
    fontSize: '13px'
  }
});

export default function AssignmentChip(props) {
  const { assigned, clickable, onClick } = props;
  return (
    <FormGroup>
      <MuiThemeProvider theme={theme}>
        <FormControlLabel
          control={
            <Chip
              size="medium"
              variant="outlined"
              clickable={clickable}
              color={assigned ? 'primary' : 'secondary'}
              icon={assigned ? <DoneIcon /> : <CloseIcon />}
              label={assigned ? 'Assigned' : 'Not assigned'}
              onClick={clickable ? onClick : {}}
            />
          }
        />
      </MuiThemeProvider>
    </FormGroup>
  );
}
